import React, { useState, useEffect } from "react";
import { fetchParentAssessmentCards, fetchIsAssessmentEnabled } from "../../api/AssessmentHelper"; // Ensure the correct import here
import { getUserId, getAccesstoken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer"; // Ensure Buffer is available
import MedicalAssessment from "./Assessments/MedicalAssessment";
import { Link } from "react-router-dom";

const ParentAssessments = () => {
    const [assessmentCards, setAssessmentCards] = useState([]);
    const authToken = getAccesstoken();
    const userId = getUserId();
    const navigate = useNavigate();
    const [isAssessmentEnabled, setIsAssessmentEnabled] = useState(null);


    const encodeData = (name, desc) => {
        const obj = { name, desc };
        return encodeURIComponent(Buffer.from(JSON.stringify(obj)).toString("base64"));
      };

    useEffect(() => {

        const fetchAssessmentStatus = async () => {
            try {
                const response = await fetchIsAssessmentEnabled(userId, authToken);
                setIsAssessmentEnabled(response.is_enabled); // Convert to boolean
            } catch (error) {
                console.error("Error fetching assessment status:", error);
                setIsAssessmentEnabled(false); // Default to false if error
            }
        };

        const fetchData = async () => {
            try {
                const cards = await fetchParentAssessmentCards('parent_assessments', { skip: 0, limit: 10, schema: 'public' }, authToken);
                setAssessmentCards(cards || []); // Update state
            } catch (error) {
                console.error("Error fetching data:", error); // Log any errors
            }
        };

        if (authToken) {
            fetchAssessmentStatus(); // Make sure authToken and userId are valid before calling fetchData
            fetchData();
        }
    }, [authToken, userId]); // Added userId as a dependency, in case it changes

    return (
        <div>
            <div className="dashboard_grey_section">
                <h1 className="font-lg mb-4">Assessments</h1>
                <div className="dashboard-user-name">
                    {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> */}
                </div>
                <div className="row mb-3">
                {isAssessmentEnabled === "Y" ? (
        <>
                    {assessmentCards.length > 0 ? (
                        assessmentCards.map((card) => (
                            <div className="col-xl-6 mb-3" key={card.id}>
                                <div className="parent-assesment-cards">
                                    <div className="dashboard-title mb-3">
                                        <div className="font-md fw-semibold">{card.name}</div>
                                    </div>
                                    <p>{card.description || "No description available."}</p>
                                    {/* <button
                                        onClick={() =>
                                           
                                            navigate(`/user/assessments/${card.id}?name=${encodeURIComponent(card.name)}&desc=${encodeURIComponent(card.description)}`)}

                                            // navigate(`/user/assessments/${card.id}/${encodeURIComponent(card.name)}/${encodeURIComponent(card.description)}`)}
                                        className="btn-assessment font-xsm btns btn-animation-blue mt-xxl-4 mt-2 home-button mend-auto"
                                    >
                                        View <i className="fa-solid fa-right-long icon"></i>
                                    </button> */}
                                    <button
    onClick={() => {
        const encodedData = encodeData(card.name, card.description);
        navigate(`/user/assessments/${card.id}?details=${encodedData}`);
    }}
    className="btn-assessment font-xsm btns btn-animation-blue mt-xxl-4 mt-2 home-button mend-auto"
>
    View <i className="fa-solid fa-right-long icon"></i>
</button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No assessments available.</p>
                    )}
                    <MedicalAssessment />
                    </>
    ) : (
        
        <p>
        This is exclusively available for Max Package users only.  
        <Link to="/shop">Click here to purchase</Link>.
      </p>
    )}
                </div>
            </div>
        </div>
    );
};

export default ParentAssessments;
